import { FIXED } from 'src/app/constants/pricingModel';

export const isHorizonHirer = (pricingModel?: string) => pricingModel !== FIXED;
